import {Injector} from '@angular/core';
import {Http, XHRBackend, RequestOptions} from '@angular/http';
import {EventManager, InterceptableHttp} from 'ng-jhipster';
import {StateStorageService} from '../../shared/auth/state-storage.service';
import {AuthExpiredInterceptor} from './auth-expired.interceptor';
import {ErrorHandlerInterceptor} from './errorhandler.interceptor';
import {NotificationInterceptor} from './notification.interceptor';
import {Router} from '@angular/router';

export function interceptableFactory(
    backend: XHRBackend,
    defaultOptions: RequestOptions,
    injector: Injector,
    stateStorageService: StateStorageService,
    eventManager: EventManager,
    router: Router
) {
    let interceptable = new InterceptableHttp(
        backend,
        defaultOptions,
        [
            new AuthExpiredInterceptor(injector, router, stateStorageService),
            // Other interceptors can be added here
            new ErrorHandlerInterceptor(eventManager),
            new NotificationInterceptor()
        ]
    );
    return interceptable;
};

export function customHttpProvider() {
    return {
        provide: Http,
        useFactory: interceptableFactory,
        deps: [
            XHRBackend,
            RequestOptions,
            Injector,
            StateStorageService,
            EventManager,
            Router
        ]
    };
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/interceptor/http.provider.ts